import React from 'react'
import ActivityProfilesList from '../ActivityProfilesList'

export default function Shortlist() {
    return (
        <ActivityProfilesList
            title={'Shortlisted Profiles'}
            url={'shortlisted'}
        />
    )
}
